//src/styles/utils/colorUtils.js
import { lighten, darken, alpha } from "@mui/material/styles";

/**
 * Get CSS variable value safely
 */
export const getCSSVariable = (name, fallback = "") => {
  if (typeof window === "undefined") return fallback;
  try {
    return getComputedStyle(document.documentElement).getPropertyValue(name).trim() || fallback;
  } catch {
    return fallback;
  }
};

/**
 * Generate color variants with alpha channels
 */
export const generateVariants = (color) => ({
  main: color,
  light: lighten(color, 0.25),
  dark: darken(color, 0.15),
  veryLight: lighten(color, 0.4),
  veryDark: darken(color, 0.25),
  alpha: {
    '5': alpha(color, 0.05),
    '10': alpha(color, 0.1),
    '15': alpha(color, 0.15),
    '20': alpha(color, 0.2),
    '25': alpha(color, 0.25),
    '30': alpha(color, 0.3),
    '40': alpha(color, 0.4),
    '50': alpha(color, 0.5),
  }
});

/**
 * Get contrast text color (black or white) based on background
 */
export const getContrastText = (color) => {
  const hex = color.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  
  // Calculate relative luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  
  return luminance > 0.5 ? "#1a1a1a" : "#ffffff";
};

const colorUtils = {
  getCSSVariable,
  generateVariants,
  getContrastText,
};

export default colorUtils;